'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _notAvailableComponent = require('../../not-available-component');

var _notAvailableComponent2 = _interopRequireDefault(_notAvailableComponent);

var _asaCompliance = require('./../../asa-compliance');

var _asaCompliance2 = _interopRequireDefault(_asaCompliance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ellipsisStyle = {
  maxWidth: '95%',
  textOverflow: 'ellipsis',
  display: 'block',
  overflow: 'hidden'
};

var ellipsisWrapper = {
  width: '100%'
};

var AssetComponent = function AssetComponent(_ref) {
  var post = _ref.post,
      viewMode = _ref.viewMode;

  var discussionName = _lodash2.default.get(post, 'trackedAsset.discussionName');
  return _react2.default.createElement(
    _semanticUiReact.Header,
    { as: 'h5' },
    _react2.default.createElement(
      _semanticUiReact.Header.Content,
      { style: ellipsisWrapper },
      discussionName || post.channelTitle || post.influencerName || post.twitterHandle || post.instagramHandle,
      _react2.default.createElement(
        _semanticUiReact.Header.Subheader,
        null,
        _react2.default.createElement(
          'span',
          { style: ellipsisStyle },
          post.title || post.text
        )
      )
    )
  );
};

var PaidPartnershipComponent = function PaidPartnershipComponent(_ref2) {
  var sponsor = _ref2.sponsor;

  var sponsorName = sponsor.name || sponsor.username;
  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(_semanticUiReact.Label, { icon: 'checkmark', basic: true, color: 'green', content: 'PP' }),
    content: 'Paid partnership with ' + sponsorName
  });
};

var AdWrapper = function AdWrapper(_ref3) {
  var post = _ref3.post;

  if (post.trackedAsset.assetType === 'STORY') {
    return _react2.default.createElement(_notAvailableComponent2.default, { metricName: '#ad', platform: post.trackedAsset.platform, assetType: 'post' });
  }
  if (post.sponsor) {
    return _react2.default.createElement(PaidPartnershipComponent, { sponsor: post.sponsor });
  }
  return _react2.default.createElement(_asaCompliance2.default, { text: post.text });
};

var DeleteButton = function DeleteButton(props) {
  return _react2.default.createElement(_semanticUiReact.Button, { value: props.value, onClick: props.handler, circular: true, compact: true, icon: 'delete' });
};

module.exports = {
  AdWrapper: AdWrapper,
  AssetComponent: AssetComponent,
  DeleteButton: DeleteButton
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/row-components.js
 ** module id = 2595
 ** module chunks = 0
 **/